<template>
  <Nav-bar :has_back="false" :has_right="false" title="Secret key授权信息"></Nav-bar>
  <div class="top-margin"></div>
  <div class="display_column container">
    <span class="t-f22-c28 font-bold">授权Secret key登录</span>
    <span class="t-f14-c78 m-t-10">点击下面按钮即可授权Secret key登录</span>
    <img src="@/images/secret_key_auth.png" class="w-i" />
    <van-button type="primary" size="normal" class="main-btn" @click="getData"
      >同意</van-button
    >
  </div>
</template>

<script>
import NavBar from "../../components/NavBar.vue";
import { useRouter, useRoute } from "vue-router";
import request from "@/api/request";
import { Toast } from "vant";
import tokenHelper from "@/helpers/token_helper";
import userHelper from "@/helpers/user_helper";

let router;
let route;

export default {
  components: {
    NavBar:NavBar
  },
  setup() {
    router = useRouter();
    route = useRoute();

    function getData() {
      authSecret(route.query.data)
    }
    function authSecret(key) {
      request
        .authSecret({
        key: key,
      })
      .then((res) => {
        tokenHelper.storeTokens(res.data.user.token);
        userHelper.storeUserinfo(res.data.user);
        Toast("登录成功!");
        // stateContext.commit("setHomeRouter", "user");
        router.replace("/");
    })
    .catch((error) => {
        let errorMsg = "登录失败，请稍后重试";
        if (error?.response?.data?.msg) {
          errorMsg = error.response.data.msg;
        }
        Toast(errorMsg);
    });
    }
    return { router, getData, authSecret};
  },
};
</script>

<style scoped>
body {
  background: #fff !important;
}
.main-btn {
  margin: 0 auto;
  margin-top: 30px;
  width: 245px;
}
.container {
  text-align: center;
  margin-top: 80px;
}
.w-i {
  height: 200px;
  width: 210px;
  margin: 0px auto;
  margin-top: 20px;
}
</style>
